// src/hooks/useCart.js

import { useCart as useCartContext } from "../features/cart/CartContext";

export const useCart = () => {
  return useCartContext();
};